import { render, staticRenderFns } from "./ShowHDRLcdCalibration2DXYGray.vue?vue&type=template&id=16323a45"
import script from "./ShowHDRLcdCalibration2DXYGray.vue?vue&type=script&lang=js"
export * from "./ShowHDRLcdCalibration2DXYGray.vue?vue&type=script&lang=js"
import style0 from "./ShowHDRLcdCalibration2DXYGray.vue?vue&type=style&index=0&id=16323a45&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports